import { iconMap } from './iconMap'
import { IconProps } from './types'
import style from './icon.module.css'
import cx from 'classnames'

export const Icon = ({ name, size = 24, className, ...props }: IconProps) => {
  const IconComponent = iconMap[name]

  if (!IconComponent) {
    if (import.meta.env.DEV) {
      console.warn(`Icon "${name}" not found in iconMap`)
    }
    return null
  }

  return (
    <IconComponent
      size={size}
      className={cx(style.icon, className)}
      {...props}
    />
  )
}
